// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"caad0077","278":"36a0a15f","504":"0737fa40","569":"2ea24810","579":"6d46ef05","762":"421cb027","881":"30244d85","994":"07023ca1"}[chunkId] + ".chunk.js";
};